import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./goodbyeToast.css";

type Props = {
  open: boolean;
  title: string;
  message?: string;
  onClose: () => void;
  durationMs?: number;
};

export default function Toast({
  open,
  title,
  message,
  onClose,
  durationMs = 3500,
}: Props) {
  const { t } = useTranslation();
  useEffect(() => {
    if (!open) return;
    const t = window.setTimeout(onClose, durationMs);
    return () => window.clearTimeout(t);
  }, [open, durationMs, onClose]);

  if (!open) return null;

  return (
    <div className="toast" role="status" aria-live="polite">
      <div className="toast__bar" />
      <div className="toast__content">
        <div className="toast__title">{title}</div>
        {message && <div className="toast__msg">{message}</div>}
      </div>
      <button className="toast__close" onClick={onClose} aria-label={t("common.close")}>
        ×
      </button>
    </div>
  );
}